export default __webpack_public_path__ + "static/media/star.6b039792.png";